// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".satisfactionMessageScale__ratingOptionContainer___1G9I7{cursor:pointer;width:50px;height:50px;background-size:contain;background-repeat:no-repeat;display:inline-block}.satisfactionMessageScale__optionContainer___3gOih{display:flex;width:100%;justify-content:space-around}.satisfactionMessageScale__labels___3LoSW{width:100%;display:flex;justify-content:space-between;margin:15px 0}.satisfactionMessageScale__label___1Xrp8{color:var(--agent-bubble-secondary-font-color)}html[dir=\"rtl\"] .satisfactionMessageScale__optionContainer___3gOih{direction:rtl}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "655px",
	"ratingOptionContainer": "satisfactionMessageScale__ratingOptionContainer___1G9I7",
	"optionContainer": "satisfactionMessageScale__optionContainer___3gOih",
	"labels": "satisfactionMessageScale__labels___3LoSW",
	"label": "satisfactionMessageScale__label___1Xrp8"
};
export default ___CSS_LOADER_EXPORT___;
